import request from '../request';

export const getServiceTypes = () =>
  request.get('servicetypes').then((res) => res);

/**
 * Save a service to a detailed itinerary day.
 * @param {number} tripid - The trip ID.
 * @param {number} tripdetaileddayid - The detailed day ID.
 * @param {Object} payload - The service data to save.
 * @returns {Promise<Object>} - The API response.
 */
export const createServiceType = async (tripid, tripdetaileddayid, payload) => {
  const url = `/trips/${tripid}/tripdetailedday/${tripdetaileddayid}/services`;
  return await request.post(url, payload);
};

/**
 * Delete a service from a detailed itinerary day.
 * @param {number} tripid - The trip ID.
 * @param {number} tripdetaileddayid - The detailed day ID.
 * @param {number} tripdetaileddayserviceid - The detailed service day ID.
 * @returns {Promise<Object>} - The API response.
 */
export const deleteServiceType = async (
  tripid,
  tripdetaileddayid,
  tripdetaileddayserviceid
) => {
  const url = `/trips/${tripid}/tripdetailedday/${tripdetaileddayid}/services/${tripdetaileddayserviceid}`;
  return await request.delete(url);
};

/**
 * Update a service to a detailed itinerary day.
 * @param {number} tripid - The trip ID.
 * @param {number} tripdetaileddayid - The detailed day ID.
 * @param {number} tripdetaileddayserviceid - The detailed service day ID.
 * @param {Object} payload - The service data to save.
 * @returns {Promise<Object>} - The API response.
 */
export const updateServiceType = async (
  tripid,
  tripdetaileddayid,
  tripdetaileddayserviceid,
  payload
) => {
  const url = `/trips/${tripid}/tripdetailedday/${tripdetaileddayid}/services/${tripdetaileddayserviceid}`;
  return await request.put(url, payload);
};

/**
 * Creates a trip service by copying from a library service (server-side).
 * @param {number} tripId - The trip ID.
 * @param {number} tripDetailedDayId - The trip detailed day ID.
 * @param {Object} payload - The payload containing itineraryserviceid and sequence.
 * @returns {Promise<Object>} Response with created service data.
 */
export const createServiceFromLibrary = async (
  tripId,
  tripDetailedDayId,
  payload
) => {
  try {
    const response = await request.post(
      `/trips/${tripId}/tripdetailedday/${tripDetailedDayId}/services/from-library`,
      payload
    );
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

/**
 * Update the sequence of services for a detailed day.
 * @param {number} [tripid=0] - The trip ID.
 * @param {number} [tripdetaileddayid=0] - The detailed day ID.
 * @param {Object} [data={}] - The data to update.
 * @returns {Promise<Object>} - The API response.
 */
export const updateTripDayServiceSequence = async (
  tripid = 0,
  tripdetaileddayid = 0,
  data = {}
) =>
  request
    .put(
      `/trips/${tripid}/tripdetailedday/${tripdetaileddayid}/servicessequence`,
      { ...data }
    )
    .then((res) => res);

export const moveServiceToAnotherDay = async (
  tripid = 0,
  tripdetaileddayid = 0,
  tripdetaileddayserviceid = 0,
  data = {}
) =>
  request
    .post(
      `/trips/${tripid}/tripdetailedday/${tripdetaileddayid}/services/${tripdetaileddayserviceid}/move`,
      { ...data }
    )
    .then((res) => res);
